// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare let __webpack_public_path__: string;

const isDesktopRuntime =
  typeof window !== 'undefined' &&
  ((window as any).desktopApp || window.location.protocol === 'file:');

// eslint-disable-next-line @typescript-eslint/no-unused-vars
__webpack_public_path__ = isDesktopRuntime ? './' : `${window.location.origin}/`;

export {};
